import React from "react";
import { Col, Form, InputGroup } from "react-bootstrap";
import ContactStyle from "../Contact.module.css";
const Phone = ({ phoneFormat, setPhoneFormat }) => {
  const labelForm = ContactStyle.labelForm;
  const phone = ContactStyle.phone;
  return (
    <>
      <Form.Label className={labelForm}>Phone Number</Form.Label>
      <Form.Group as={Col} sm={12}>
        <InputGroup hasValidation>
          <Form.Control
            className={phone}
            name="phone"
            type="tel"
            pattern="[0-9]{3}[0-9]{3}[0-9]{4}"
            required
            value={phoneFormat}
            onChange={(e) => setPhoneFormat(e.target.value)}
          />
          <Form.Control.Feedback type="invalid">
            Please enter a valid phone number format
          </Form.Control.Feedback>
        </InputGroup>
      </Form.Group>
    </>
  );
};
export default Phone;
